import { render, staticRenderFns } from "./AvaliacaoFormacaoDialog.vue?vue&type=template&id=72e0b09c"
import script from "./AvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"
export * from "./AvaliacaoFormacaoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports